// Share-channel URLs for the Home booking-link card (design shareFb/Wa/Tg/Sms/Email,
// M:10250-10260). Each channel's public share intent with the link as the payload;
// Instagram has no web share intent, so the card copies the link instead. The link is
// the registry-built public URL (web_base_url, API-49) — nothing here names a tenant.
export type ShareChannel = 'facebook' | 'whatsapp' | 'instagram' | 'telegram' | 'sms' | 'email';

export const SHARE_CHANNELS: readonly ShareChannel[] = ['facebook', 'whatsapp', 'instagram', 'telegram', 'sms', 'email'];

export function shareIntent(channel: ShareChannel, url: string): string | null {
  const u = encodeURIComponent(url);
  switch (channel) {
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${u}`;
    case 'whatsapp':
      return `https://wa.me/?text=${u}`;
    case 'telegram':
      return `https://t.me/share/url?url=${u}`;
    case 'sms':
      return `sms:?&body=${u}`;
    case 'email':
      return `mailto:?body=${u}`;
    case 'instagram':
    default:
      return null;
  }
}
